import Api from '../services/Api'
import moment from "moment";



export default {
  getRates(token) {
    const headerData = {
      headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json;version=1.1'
      }
    }
    const postData = {
      category_id: 0,
      from_date: moment()
        .startOf("year")
        .format("YYYY-MM-DD"),
      to_date: moment()
      .endOf("year")
      .add(3, "years")
      .format("YYYY-MM-DD")
    }
    return Api().post('/price/', postData, headerData)
  },
  postExcel(token, formData) {
    const headerData = {
      headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json;version=1.1;sandbox'
        
      }
    }
    return Api().post('/price/upload/', formData, headerData)
  },
  importRates(token, fileuploaded) {
    const headerData = {
      headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json;version=1.1;sandbox'
      }
    }
    const postData = {
      fileuploaded: fileuploaded
    }
    return Api().put('/price/upload/', postData, headerData)
  }
}
